import { inject, Service, signal } from '@angular/core';
import { MgsWebApi } from '../../mgs-webapi.service';
import { IDienstleistungInfo } from '@mng/mgs-lib';
import { firstValueFrom } from 'rxjs';

@Service()
export class DienstleistungAdminBearbeitungService {
  readonly webApi = inject(MgsWebApi);

  #dienstleistung = signal<IDienstleistungInfo>(undefined);
  dienstleistung = this.#dienstleistung.asReadonly();

  async load(code: string) {
    const dienstleistung = (await firstValueFrom(this.webApi.dienstleistungFuerAdmin(code))).data.result;
    this.#dienstleistung.set(dienstleistung);
  }

  async speichern(dienstleistung: IDienstleistungInfo) {
    dienstleistung = (await firstValueFrom(this.webApi.dienstleistungFuerAdminSpeichern(dienstleistung))).data.result;
    this.#dienstleistung.set(dienstleistung);
  }
}
